import { Link } from "react-router-dom";
import { Home as HomeIcon, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-[68vh] bg-white flex items-center" data-testid="page-not-found">
      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-1 md:grid-cols-2 gap-12 items-center w-full">
        <div>
          <div className="font-heading font-black text-[120px] sm:text-[160px] leading-none text-brand-orange tracking-tighter">404</div>
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl text-brand-ink tracking-tight mt-2 mb-3">Page Not Found</h1>
          <p className="text-base text-brand-ink/70 mb-7 max-w-md leading-relaxed">
            The page you're looking for has wandered off the farm. Let's get you back to safe pasture.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link to="/" data-testid="notfound-home-cta" className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeDark text-white font-heading font-semibold text-sm px-6 py-3.5 rounded-md transition-colors">
              <HomeIcon size={16} /> Go Home
            </Link>
            <Link to="/products" data-testid="notfound-products-cta" className="inline-flex items-center gap-2 bg-white text-brand-ink border border-brand-line hover:border-brand-orange hover:text-brand-orange font-heading font-semibold text-sm px-6 py-3.5 rounded-md transition-colors">
              Browse Products <ArrowRight size={16} />
            </Link>
          </div>
        </div>
        <div className="hidden md:block">
          <div className="aspect-square rounded-lg overflow-hidden border border-brand-line">
            <img
              src="https://images.unsplash.com/photo-1500595046743-cd271d694d30?auto=format&fit=crop&w=900&q=70"
              alt="Cattle in field"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
